import { useCurrentTeamMember } from '@/providers/TeamMemberProvider';
import { usePurchaseOrderContractTaskActivities } from '@/hooks/api/0920_purchase_order_contract_task_activities';
import { ActivityRow } from '@/components/features/ActivityRow';
import { useCurrentPurchaseOrderContractTask } from '@/providers/PurchaseOrderContractTaskProvider';
import { MotionDiv } from '@/components/element/MotionDiv';
import { useParams } from 'react-router-dom';

export const Activities = () => {
  const { _w_, _t_, me, meTeamMember } = useCurrentTeamMember();
  const { purchase_order_id } = useParams();
  const { purchaseOrderContractTask: task } = useCurrentPurchaseOrderContractTask();
  const { data: activities } = usePurchaseOrderContractTaskActivities({
    identifier: _w_!.identifier,
    team_id: _t_!.id,
    purchase_order_id: Number(purchase_order_id),
    id: task!.id,
  });

  return (
    <MotionDiv className="card mb-4">
      <div className="card-header d-flex align-items-center justify-content-between">
        <div>
          <h6 className="mb-0">タスクの変更履歴</h6>
        </div>
      </div>
      <div className="card-body pt-0">
        <div className="timeline timeline-one-side" data-timeline-axis-style="dotted">
          {activities?.map((d) => <ActivityRow key={`activity-${d.id}`} d={d} />)}
        </div>
      </div>
    </MotionDiv>
  );
};
